import React from 'react'
import { Typography } from '@material-ui/core'

import { ICorporation } from '../../../graphql/types/businesses'
import { Link } from 'react-router-dom'

interface IProps {
  item: ICorporation
}

export const BusinessesCountColumn: React.FC<IProps> = ({ item }) => {
  const count = item.businessesCount ?? 0

  if (count === 0) {
    return (
      <Typography color='textSecondary' variant='body2'>
        {count}
      </Typography>
    )
  }

  return (
    <Typography color='textPrimary' variant='subtitle2' component={Link} to={`/businesses?corporationId=${item.id}`}>
      {count}
    </Typography>
  )
}
